<template>
    <div>
      <v-text-field
        v-bind="$attrs"
        :id="id.toString()"
        ref="DateInput"
        v-model="date"
        filled
        :readonly="readonly"
        :required="required"
        :label="propLabel"
        v-on="listeners()"
      >
        <template #append>
          <v-icon
            v-if="!readonly"
            @click="show = true"
          >
            mdi-calendar
          </v-icon>
          <v-icon
          v-if="model && model.__proxy__ && model.__proxy__.isDirty(def.name)"
            @click="model && model.__proxy__ && model.__proxy__.undo(def.name)"
          >
            mdi-undo
          </v-icon> 
        </template>
        <template #label>
          <div>
            {{ propLabel }}<span
              v-if="def.required"
              class="red--text font-weight-bold"
            > *</span>
          </div>
        </template>
      </v-text-field>
      <date-picker
        append-to="#app"
        auto-submit
        :locale="locale"
        :show="show"
        :editable="true"
        :element="id.toString()"
        format="YYYY/MM/DD HH:mm:ss"
        display-format="jYYYY/jMM/jDD JHH:Jmm:Jss"
        type="datetime"
        @close="show=false"
        @change="change"
      />
    </div>
  </template>
  
  <script>
  import jalali from "moment-jalaali";
  import moment from "moment";
  import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
  
  export default {
    name: "AppDateAndTimePicker",
    components: {datePicker: VuePersianDatetimePicker},
    props: ["def" ,"model", "required", "readonly", "locale"],
    data: vm => ({
      show: false,
      id: Symbol(vm.def.id),
      Model: vm.model,
value: vm.model[vm.def.name]
  ? vm.locale == 'fa'
    ? jalali(vm.model[vm.def.name]).format("jYYYY/jMM/jDD HH:mm:ss")
    : moment(vm.model[vm.def.name]).format("YYYY/MM/DD HH:mm:ss")
  : undefined
    }),
    computed: {
date: {
  set(payload) {
    payload = this.persianToEnglishNumber(payload);

    const fmt = "jYYYY/jMM/jDD HH:mm:ss";
    const m = jalali(payload, fmt, true); // strict

    if (!m.isValid()) {
      this.$set(this.model, this.def.name, "Invalid date");
      this.value = payload;
      return;
    }

    const newDate = m.format("YYYY-MM-DD HH:mm:ss");
    this.$set(this.model, this.def.name, newDate);

    this.value = m.format(fmt);
  },
  get() {
    return this.value;
  }
},

      propLabel() {
        let label = this.$t(this.def);
        return label;
      }
    },
    created() {
      this.$watch("model", nv => {
        if("condition" in nv && nv.value === undefined) {
          this.value = undefined
        }
      }, { deep: true });
    },
    updated(){
      if("condition" in this.model && this.value) {
          this.$set(this.model , 'value' , jalali(this.value , 'jYYYY/jMM/jDD HH:mm:ss').format("YYYY/MM/DD HH:mm:ss"))
        }
    },
    methods: {
      listeners(){
        const listeners = this.$listeners;
        delete listeners["input"];
        return listeners;
      },
      change(newValue) {
        this.date = newValue.format('jYYYY/jMM/jDD HH:mm:ss');
        this.$nextTick(() => (this.$refs["DateInput"].focus()));
      },
      persianToEnglishNumber(str){
        const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g]
        if(typeof str === 'string')
        {
          for(var i=0; i<10; i++)
          {
            str = str.replace(persianNumbers[i], i);
          }
        }
        return str;
      }
    },
  }
  </script>
  
  <style scoped>
  .custom-date {
    border: none!important;
    border-bottom: solid 2px #ccc!important;
  }
  .v-input__slot{
    padding-bottom: 0 !important;
  }
  .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
    padding: 0 12px;
    border: solid red 1px;
    border-radius: 10px;
    background-color: white;
  }
  .v-text-field > .v-input__control > .v-input__slot:before, .v-text-field > .v-input__control > .v-input__slot:after {
    bottom: 0;
    content: "";
    left: 0;
    position: absolute;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;
    visibility: hidden;
  }
  .v-text-field--filled .v-label--active, .v-text-field--full-width .v-label--active {
    transform: translateY(-10px) scale(0.75);
  }
  </style>